





























































































































































import BaseComponent from '@/core/base.component';
import { AnalysisTabListDto } from '@/dto';
import AnalysisTabService from '@/services/analysis/analysis-tab.service';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ReverseQueryParamMapper } from '@/core';

@Component({
  name: 'AnalysisCategory',
})
export default class AnalysisCategory extends BaseComponent {
  @Prop() bdongCode!: string;
  private analysisTabSearchDto = new AnalysisTabListDto();
  private categories = [];
  private survivalYears = [];
  private dataLoading = true;
  private dataLoadingFoodCategory = true;
  private dataLoadingSurvivalYears = false;
  private maxCntRatio = null;
  private maxAvgRatio = null;
  private maxGapPer = null;

  findFoodCategorySummary() {
    this.dataLoadingFoodCategory = true;
    AnalysisTabService.findFoodCategorySummary(
      this.analysisTabSearchDto,
    ).subscribe(res => {
      if (res) {
        this.dataLoadingFoodCategory = false;
        this.categories = res.data;
        const maxCntRatioArr = this.categories.map(data => {
          return data.storeCntRatio;
        });
        this.maxCntRatio = Math.max(...maxCntRatioArr);
        const maxAvgRatioArr = this.categories.map(data => {
          return data.w_total_amt_avg_ratio;
        });
        this.maxAvgRatio = Math.max(...maxAvgRatioArr);
        const maxGapPerArr = this.categories.map(data => {
          return data.gapPer;
        });
        this.maxGapPer = Math.max(...maxGapPerArr);
      }
    });
  }

  findSurvivalYears() {
    this.dataLoadingSurvivalYears = true;
    AnalysisTabService.findSurvivalYears(this.analysisTabSearchDto).subscribe(
      res => {
        if (res) {
          this.dataLoadingSurvivalYears = false;
          this.survivalYears = res.data;
        }
      },
    );
  }

  findAnalysisCategory() {
    this.findFoodCategorySummary();
    this.findSurvivalYears();
  }

  // created() {
  //   const query = ReverseQueryParamMapper(location.search);
  //   if (query) {
  //     this.analysisTabSearchDto = query;
  //     this.findAnalysisCategory();
  //   }
  // }

  created() {
    setTimeout(() => {
      this.analysisTabSearchDto.bdongCode = this.bdongCode;
      this.findAnalysisCategory();
    }, 1000);
  }
}
